import { containersListPagedOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("container-paged"),
  endpoint: "containers/list-paged",
  operations: containersListPagedOps,
  listEndpoint: "containers/list",
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  singularName: (t) => t("Container"),
  name: (t) => t("Containers"),
  initialFilter: {
    status: "all",
  },
  syncCustomerFilter: true,
  dependencies: ["region-code"],
});

export default conf;
